import React from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import LocationIcon from '../../../assets/images/location-sign.svg';
import WVFabricon from '../../../assets/images/wavexchange-small-icon.svg';
import VerifiedPort from '../../../assets/images/port-green.svg';
import UnverifiedPort from '../../../assets/images/port-grey.svg';
import ListedPort from '../../../assets/images/port-yellow.svg';
import SoldPort from '../../../assets/images/port-red.svg';
import Globe from '../../../assets/images/globe.svg';
import { AuthRoutes, Roles } from '../../../enums';
import AuthService from '../../../services/auth.service';
import ManagePortIcon from '../../../assets/images/manage-port.svg';
import AddPortIcon from '../../../assets/images/add-port.svg';
import { sumCount } from '../../../utils/methods';
import { countType } from '../../../utils/appConstants';

interface NEDetailsProps {
  ne: any;
}

const NEDetails: React.FC<NEDetailsProps> = ({ ne }) => {
  const address = `${ne.street}, ${ne.city}, ${ne.state} ${ne.zip}`;
  const { on_net, management_ip } = ne;
  const isAdmin = AuthService.getRole() == Roles.admin;
  const navigate = useNavigate();

  const countObj: countType = ne?.nrCount || {
    verified: 0, unverified: 0, sold: 0, bought: 0, listed: 0,
  };
  const sum = sumCount(countObj);
  return (
    <div className="ne-details-form">
      <div className="title">
        <label>
          {sum}
          {' '}
          Network Resource/s
        </label>
      </div>
      <br />

      <div className="title-info">
        {(on_net) ? <img src={WVFabricon} alt="fabricon" /> : ''}
        <label>{ne.ne_name}</label>
      </div>

      <br />

      <ul className="list-elements">
        <li>
          <img src={LocationIcon} alt="location-icon" />
          <label>{address}</label>
        </li>
        {(isAdmin && management_ip && on_net) ? (
          <li>
            <img src={Globe} alt="location-icon" />
            <a href={management_ip} target={management_ip}><label>Link to Switch Management Page</label></a>
          </li>
        )
          : ''}
      </ul>
      <br />
      {(sum > 0) && <label>Network Resources:</label>}
      <ul className="list-elements">
        { (countObj.verified > 0)
          ? (
            <li>
              <img src={VerifiedPort} alt="verified-port" />
              <label>{`${countObj.verified} on WaveXchange`}</label>
            </li>
          ) : ''}
        { (countObj.bought > 0)
          ? (
            <li>
              <img src={VerifiedPort} alt="bought-port" />
              <label>{`${countObj.bought} purchased on WaveXchange`}</label>
            </li>
          ) : ''}
        { (countObj.listed > 0)
          ? (
            <li>
              <img src={ListedPort} alt="listed-port" />
              <label>{`${countObj.listed} listed in the Marketplace`}</label>
            </li>
          ) : ''}
        { (countObj.sold > 0)
          ? (
            <li>
              <img src={SoldPort} alt="sold-port" />
              <label>{`${countObj.sold} sold in the Marketplace`}</label>
            </li>
          ) : ''}
        { (countObj.unverified > 0)
          ? (
            <li>
              <img src={UnverifiedPort} alt="unverified-port" />
              <label>{`${countObj.unverified} offline`}</label>
            </li>
          ) : ''}

      </ul>

      <br />
      <div className={clsx(on_net && 'on-bg', 'manage-resources', !on_net && 'off-bg')}>
        <ul>
          {(sum > 0) && (
            <li onClick={() => navigate(AuthRoutes.managePorts, { state: ne.id })}>
              <img src={ManagePortIcon} alt="Manage Ports" />
              <label>Manage Network Resources</label>
            </li>
          )}
          <li onClick={() => navigate(AuthRoutes.addPort, { state: ne.id })}>
            <img src={AddPortIcon} alt="Add Ports" />
            <label>Add Network Resources</label>
          </li>
          {/* <li>
            <img onClick={() => navigate(AuthRoutes.manageBandwidth, { state: ne })} src={ManageLinkIcon} alt="Manage Port Links" />
            <label onClick={() => navigate(AuthRoutes.manageBandwidth, { state: ne })}>Link to Manage Bandwidth</label>
          </li> */}
        </ul>

      </div>

    </div>
  );
};

export default NEDetails;
